import React, { useContext } from 'react';
import { ConnectButton } from '@rainbow-me/rainbowkit';
import './connection_new.scss';

import { MobileContext } from 'context';
import { useIsWantedChainActive } from 'utils/Hooks';


export default function ConnectButtonRK() {
  const isMobile = useContext(MobileContext);
  const isWantedChainActive = useIsWantedChainActive();

  const cssClass = 'ThemeButton FlexCenter RKButton' + (isMobile ? ' Mobile' : '');

  function renderConnectChild({
    account,
    chain,
    openAccountModal,
    openChainModal,
    openConnectModal,
    authenticationStatus,
    mounted,
  }: any) {
    const ready = mounted && authenticationStatus !== 'loading';
    const connected = (ready && account && chain) &&
      (!authenticationStatus || authenticationStatus === 'authenticated');

    if (!connected) {
      return (
        <button
          onClick={openConnectModal}
          className={cssClass}
        >
          CONNECT 
        </button>
      );
    }

    if (chain?.unsupported) {
      return (
        <button
          onClick={openChainModal}
          className={cssClass + 'WrongNet'}
        >
          WRONG NET
        </button>
      );
    }

    const address = account?.address || '';
    let formattedAddr = 'error';
    if (isMobile)
      formattedAddr = address.slice(0, 4) + '..' + address.slice(-4);
    else
      formattedAddr = address.slice(0, 6) + '...' + address.slice(-4);

    return (
      <button
        onClick={openAccountModal}
        className={cssClass}
      >
        {formattedAddr}
      </button>
    );
  }

  return (<div className='ConnectButtonRK'>
    <ConnectButton.Custom>
      {renderConnectChild}
    </ConnectButton.Custom>
  </div>);
}